"use strict";
/**
 * QVET Inventory Constants
 *
 * Constants related to inventory management: countable sections,
 * sort priorities, and expiration date requirements.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FAMILIES_REQUIRE_EXPIRATION = exports.SECTIONS_REQUIRE_EXPIRATION = exports.SECTION_SORT_PRIORITY = exports.INVENTORY_COUNTABLE_SECTIONS_SET = exports.INVENTORY_COUNTABLE_SECTIONS = void 0;
const qvet_catalog_1 = require("./qvet-catalog");
// =============================================================================
// COUNTABLE SECTIONS (Physical items, not services)
// =============================================================================
/**
 * Sections that are countable for inventory (physical items, not services)
 * Excludes: OTROS SERVICIOS, SERVICIOS EXTERNOS, SERVICIOS MEDICOS
 *
 * @deprecated Localiza las secciones **por nombre**: cuando QVET renombra una, deja de casar y
 * esa sección se cae del inventario en silencio. La verdad vive en `section_settings` (por id)
 * y se sirve por `GET /api/qvet/inventory/sections` → {@link QvetSectionSettingsResponse}.
 *
 * Sigue aquí porque la lee el sembrador y el guardián que vigila su desfase. Se borra con el
 * despliegue de GH527, cuando `section_settings` esté sembrada en producción.
 */
exports.INVENTORY_COUNTABLE_SECTIONS = [
    qvet_catalog_1.QVET_SECTIONS.CONSUMO_INTERNO,
    qvet_catalog_1.QVET_SECTIONS.EQUIPAMIENTO,
    qvet_catalog_1.QVET_SECTIONS.FARMACIA,
    qvet_catalog_1.QVET_SECTIONS.FARMACIA_INTERNA,
    qvet_catalog_1.QVET_SECTIONS.INSUMOS_ESCANDALLO,
    qvet_catalog_1.QVET_SECTIONS.INSUMOS_MEDICOS,
    qvet_catalog_1.QVET_SECTIONS.OTROS_ARTICULOS,
];
/**
 * Set for quick lookup of countable sections
 *
 * @deprecated Localiza las secciones **por nombre**: cuando QVET renombra una, deja de casar y
 * esa sección se cae del inventario en silencio. La verdad vive en `section_settings` (por id)
 * y se sirve por `GET /api/qvet/inventory/sections` → {@link QvetSectionSettingsResponse}.
 *
 * Sigue aquí porque la lee el sembrador y el guardián que vigila su desfase. Se borra con el
 * despliegue de GH527, cuando `section_settings` esté sembrada en producción.
 */
exports.INVENTORY_COUNTABLE_SECTIONS_SET = new Set(exports.INVENTORY_COUNTABLE_SECTIONS);
// =============================================================================
// SORT PRIORITY
// =============================================================================
/**
 * Priority sections for sorting (appear first in count sheets)
 *
 * @deprecated Localiza las secciones **por nombre**: cuando QVET renombra una, deja de casar y
 * esa sección se cae del inventario en silencio. La verdad vive en `section_settings` (por id)
 * y se sirve por `GET /api/qvet/inventory/sections` → {@link QvetSectionSettingsResponse}.
 *
 * Sigue aquí porque la lee el sembrador y el guardián que vigila su desfase. Se borra con el
 * despliegue de GH527, cuando `section_settings` esté sembrada en producción.
 */
exports.SECTION_SORT_PRIORITY = [
    qvet_catalog_1.QVET_SECTIONS.FARMACIA,
    qvet_catalog_1.QVET_SECTIONS.FARMACIA_INTERNA,
    qvet_catalog_1.QVET_SECTIONS.INSUMOS_MEDICOS,
];
// =============================================================================
// EXPIRATION DATE REQUIREMENTS
// =============================================================================
/**
 * Sections that ALWAYS require expiration date tracking
 *
 * @deprecated Localiza las secciones **por nombre**: cuando QVET renombra una, deja de casar y
 * esa sección se cae del inventario en silencio. La verdad vive en `section_settings` (por id)
 * y se sirve por `GET /api/qvet/inventory/sections` → {@link QvetSectionSettingsResponse}.
 *
 * Sigue aquí porque la lee el sembrador y el guardián que vigila su desfase. Se borra con el
 * despliegue de GH527, cuando `section_settings` esté sembrada en producción.
 */
exports.SECTIONS_REQUIRE_EXPIRATION = [
    qvet_catalog_1.QVET_SECTIONS.FARMACIA,
    qvet_catalog_1.QVET_SECTIONS.FARMACIA_INTERNA,
];
/**
 * Specific families within sections that require expiration date tracking
 *
 * @deprecated Localiza las secciones **por nombre**: cuando QVET renombra una, deja de casar y
 * esa sección se cae del inventario en silencio. La verdad vive en `section_settings` (por id)
 * y se sirve por `GET /api/qvet/inventory/sections` → {@link QvetSectionSettingsResponse}.
 *
 * Sigue aquí porque la lee el sembrador y el guardián que vigila su desfase. Se borra con el
 * despliegue de GH527, cuando `section_settings` esté sembrada en producción.
 */
exports.FAMILIES_REQUIRE_EXPIRATION = {
    [qvet_catalog_1.QVET_SECTIONS.INSUMOS_MEDICOS]: ['SOLUCIONES'],
    [qvet_catalog_1.QVET_SECTIONS.INSUMOS_ESCANDALLO]: ['VACUNAS'],
};
